import $api from '@/http/index';
import { IDataGridDescriptionResponse } from '@models/response/IDataGridDescriptionResponse';
import { IGridExportSettings } from '@models/response/IGridExportSettings';
import { IGridResponse } from '@models/response/IGridResponse';
import { IDataGridService } from '@services/IDataGridService';
import { AxiosResponse } from 'axios';
import { IDocumentResult } from '@models/document/IDocumentResult';
import { FilesService } from '@services/FilesService';
import { IBackgroundJobStarted } from '@models/backgroundJobs/IBackgroundJob';
import { BACKGROUND_START_REQUEST } from '@services/BackgroundJobsService';

export class DocumentLinksService extends IDataGridService {
    documentId: string;
    actionId?: string;
    rootDocumentId: string;
    
    constructor(docId?: string, actionId?: string, rootDocId?: string) {
        super();
        this.documentId = docId ?? '-1';
        this.actionId = actionId;
        this.rootDocumentId = rootDocId ?? '-1';
    }

    fetchDetailData(_data: any, _detailData: any, _loadOptions: any): Promise<AxiosResponse<IGridResponse, any>> {
        throw new Error('Method not implemented.');
    }

    async fetchScheme(data: any): Promise<AxiosResponse<IDataGridDescriptionResponse, any>> {
        if (this.documentId === '-1') {
            if (!this.actionId) {
                throw new Error('Отсутствует documentId и actionId при получении схемы грида линков');
            }

            return $api.get<IDataGridDescriptionResponse>(`/document/linkSchemeByAction/${this.actionId}/${data}`);
        } else {
            return $api.get<IDataGridDescriptionResponse>(`/document/linkScheme/${this.documentId}/${data}`);
        }
    }

    async fetchData(data: any, loadOptions: any, signal?: AbortSignal): Promise<AxiosResponse<IGridResponse, any>> {
        return $api.post<IGridResponse>(
            `/document/linkData/${this.rootDocumentId ?? '-1'}/${this.documentId ?? '-1'}/${data}`,
            loadOptions,
            { signal },
        );
    }

    async fetchCount(tableKey: any): Promise<AxiosResponse<number, any>> {
        return $api.get<number>(`/document/linkCount/${this.rootDocumentId ?? '-1'}/${this.documentId ?? '-1'}/${tableKey}`);
    }

    async putData(data: any): Promise<AxiosResponse<IDocumentResult, any>> {
        return $api.put<IDocumentResult>(`/document/linksUpdate`, data);
    }

    async exportData(
        template: string,
        options: any,
        columns: IGridExportSettings[],
        maxItemsCount?: number,
    ): Promise<void> {
        const url = `document/exportLinkedDocGrid?rootDocId=${this.rootDocumentId ?? '-1'}&docId=${this.documentId ?? '-1'}&gridKey=${template}`;
        await FilesService.downloadFilePost(url, { options, columns, maxItemsCount });
    }

    async exportDataInBackground(
        template: string,
        options: any,
        columns: IGridExportSettings[],
        maxItemsCount?: number,
    ): Promise<IBackgroundJobStarted> {
        const response = await $api.post<IBackgroundJobStarted>(
            '/document/exportLinkedDocGridInBackground',
            { options, columns, maxItemsCount },
            {
                ...BACKGROUND_START_REQUEST,
                params: { rootDocId: this.rootDocumentId ?? '-1', docId: this.documentId ?? '-1', gridKey: template },
            },
        );
        return response.data;
    }
}
